import styled from 'styled-components';
import { themeGet } from '../../foundation/theme/themeGet/get.js';

var Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-18svdcy-0"
})(["display:flex;flex-direction:column;align-items:center;justify-content:center;gap:", ";padding:", " 0;"], themeGet('spacing.3xl'), themeGet('spacing.7xl'));
var Actions = styled.div.withConfig({
  displayName: "Actions",
  componentId: "sc-18svdcy-1"
})(["display:flex;gap:", ";flex-direction:", ";"], function (_ref) {
  var $size = _ref.$size;
  return $size === 'small' ? themeGet('spacing.lg') : themeGet('spacing.xl');
}, function (_ref2) {
  var $direction = _ref2.$direction;
  return $direction === 'vertical' ? 'column' : 'row';
});

export { Actions, Container };
